import { useState } from "react";
import { Product, ProductProvider } from "@made-people/grease-product";
import {
  ProductTemplate,
  ProductTemplateAsSalzburgProps,
} from "@made-people/blueprint-product";
import { QuickShopColorPicker } from "./QuickShopColorPicker";

export const QuickShopProductSwitcher = ({
  products,
  baseProductId,
  heading,
  description,
  variants,
}: {
  products: Product[];
  baseProductId: string;
  heading?: string;
  description?: string;
  variants?: ProductTemplateAsSalzburgProps["variants"];
}) => {
  const [selectedProductId, setSelectedProductId] = useState<
    string | undefined
  >(baseProductId);

  if (!selectedProductId || products.length === 0) {
    return null;
  }

  const selectedProduct =
    products.find((p) => p.base.productId === selectedProductId) || products[0];

  return (
    <div className="w-full max-w-screen-2xl mx-auto my-4 lg:my-12">
      <ProductProvider
        product={selectedProduct}
        context={{ type: "pdp" }}
        fireOnMount={true}
      >
        <ProductTemplate
          template="salzburg"
          variants={variants}
          nameSettings={{
            text: heading && heading.length > 0 ? heading : undefined,
            asLink: true,
          }}
          descriptionSettings={{
            text:
              description && description.length > 0 ? description : undefined,
          }}
          customSiblings={
            <QuickShopColorPicker
              allProducts={products}
              selectedProductId={selectedProductId}
              onColorChange={setSelectedProductId}
            />
          }
        />
      </ProductProvider>
    </div>
  );
};
